import { FieldValues } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { GenericInputField } from '../../../../generic/GenericInputField';
import { FirstNameInput } from '../../../BasePersonInputs/FirstName/FirstNameInput';

export function FirstNameField<TValues extends FieldValues>(
  props: FieldProps<TValues>
) {
  return (
    <GenericInputField<TValues>
      {...props}
      Input={FirstNameInput}
      label='Vorname'
    />
  );
}
